import img1 from '../../../Assets/Images/1.jpg';
import img2 from '../../../Assets/Images/2.jpg';
import img3 from '../../../Assets/Images/3.jpg';
import img4 from '../../../Assets/Images/4.jpg';



const BoltIcon = () => (
  <svg className="w-3.5 h-3.5" fill="#4ade80" viewBox="0 0 24 24">
    <path d="M13 2L4.5 13.5H11L10 22L19.5 10.5H13L13 2Z" />
  </svg>
);

const LocationIcon = () => (
  <svg viewBox="0 0 28 28" width="22" height="22" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2C9.6 2 6 5.6 6 10c0 6 8 16 8 16s8-10 8-16c0-4.4-3.6-8-8-8z" />
    <circle cx="14" cy="10" r="3" />
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 28 28" width="22" height="22" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="6" width="22" height="16" rx="2" />
    <path d="M3 8l11 8 11-8" />
  </svg>
);

const PhoneRingIcon = () => (
  <svg viewBox="0 0 28 28" width="22" height="22" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 4h5l2 5-3 2a12 12 0 005 5l2-3 5 2v5a2 2 0 01-2 2C9 22 6 13.5 6 6a2 2 0 011-2z" />
    <path d="M18 4a6 6 0 016 6" />
    <path d="M18 8a2 2 0 012 2" />
  </svg>
);

const ShareIcon = () => (
  <svg viewBox="0 0 28 28" width="22" height="22" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="20" cy="5" r="3" />
    <circle cx="8" cy="14" r="3" />
    <circle cx="20" cy="23" r="3" />
    <path d="M11 12.5l6.5-5M11 15.5l6.5 5" />
  </svg>
);

// Social icons
const FbIcon = () => (
  <svg viewBox="0 0 20 20" width="16" height="16" fill="white">
    <path d="M15 2h-2.5A3.5 3.5 0 009 5.5V8H7v3h2v7h3v-7h2.5l.5-3H12V5.5a.5.5 0 01.5-.5H15V2z" />
  </svg>
);
const TwIcon = () => (
  <svg viewBox="0 0 20 20" width="16" height="16" fill="white">
    <path d="M18 4a7.8 7.8 0 01-2.24 1.08 3.2 3.2 0 00-5.6 2.14v.72A7.6 7.6 0 013 5s-3 6.5 3.5 9.5A8.3 8.3 0 012 16c6.5 3.5 14.5 0 14.5-8.25 0-.19 0-.37-.02-.56A5.52 5.52 0 0018 4z" />
  </svg>
);
const LiIcon = () => (
  <svg viewBox="0 0 20 20" width="16" height="16" fill="white">
    <path d="M16 3a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h12zM7.5 8H6v6h1.5V8zM6.75 7a.88.88 0 100-1.75A.88.88 0 006.75 7zM14 10.8c0-1.5-.8-2.8-2.2-2.8-.7 0-1.3.3-1.8.9V8H8.5v6H10v-3.4c0-.8.4-1.4 1.1-1.4.7 0 1.4.4 1.4 1.4V14H14v-3.2z" />
  </svg>
);
const IgIcon = () => (
  <svg viewBox="0 0 20 20" width="16" height="16" fill="white">
    <rect x="2" y="2" width="16" height="16" rx="4" stroke="white" strokeWidth="1.5" fill="none" />
    <circle cx="10" cy="10" r="3.5" stroke="white" strokeWidth="1.5" fill="none" />
    <circle cx="14.5" cy="5.5" r="1" fill="white" />
  </svg>
);

const cards = [
  {
    id: 1,
    image: img4,
    BadgeIcon: LocationIcon,
    label: "Our Addresses:",
    content: (
      <p className="text-gray-600 text-sm leading-relaxed">
        Head Office Address -432/2295,<br/> Backside of Odean Talkies,<br />Po- Sahadevkhunta, Baleshwar, 756001
      </p>
    ),
  },
  {
    id: 2,
    image: img3,
    BadgeIcon: MailIcon,
    label: "Emails:",
    content: (
      <div className="flex flex-col gap-1">
        <a href="mailto:info@domainname.com" className="text-gray-600 text-sm hover:text-green-600 transition-colors">info@viswarajaent.com</a>
        <a href="mailto:sales@domainname.com" className="text-gray-600 text-sm hover:text-green-600 transition-colors">sales@viswaraja.com</a>
      </div>
    ),
  },
  {
    id: 3,
    image: img2,
    BadgeIcon: PhoneRingIcon,
    label: "Phones:",
    content: (
      <div className="flex flex-col gap-1">
        <a href="tel:+918249675658 " className="text-gray-600 text-sm hover:text-green-600 transition-colors">+91 8249675658 </a>
        <a href="tel:+918249976242" className="text-gray-600 text-sm hover:text-green-600 transition-colors">+91 8249976242</a>
      </div>
    ),
  },
  {
    id: 4,
    image: img1,
    BadgeIcon: ShareIcon,
    label: "Follow Us:",
    content: (
      <div className="flex items-center gap-2 mt-1">
        {[FbIcon, TwIcon, LiIcon, IgIcon].map((Icon, i) => (
          <a
            key={i}
            href="#"
            className="flex items-center justify-center rounded-lg transition-opacity hover:opacity-80"
            style={{
              width: "34px", height: "34px",
              background: "linear-gradient(135deg, #4ade80 0%, #22c55e 100%)",
            }}
          >
            <Icon />
          </a>
        ))}
      </div>
    ),
  },
];

export default function ContactDetails() {
  return (
    <div
      className="w-full py-16 px-6 md:px-10 lg:px-12 xl:px-20 bg-white"
      style={{ fontFamily: "'Barlow', 'Montserrat', sans-serif" }}
    >
      <div className="">

        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-1.5 mb-3">
            <BoltIcon />
            <span className="text-sm font-rajdhani font-bold tracking-[0.2em] uppercase" style={{ color: "#4ade80" }}>
              CONTACT DETAILS
            </span>
          </div>
          <h2
            className="font-bold text-[#1a2e0a] font-rajdhani text-2xl md:text-4xl lg:text-[45px] leading-relaxed "
            style={{ letterSpacing: "-0.02em" }}
          >
            Happy to Answer All Your Questions
          </h2>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cards.map(({ id, image, BadgeIcon, label, content }) => (
            <div
              key={id}
              className="group relative rounded-3xl overflow-hidden cursor-pointer transition-shadow duration-300 hover:shadow-xl"
              style={{ boxShadow: "0 4px 20px rgba(0,0,0,0.07)" }}
            >
              {/* Image top */}
              <div className="relative overflow-hidden" style={{ height: "260px" }}>
                <img
                  src={image}
                  alt={label}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {/* Green badge top-right */}
                <div
                  className="absolute top-4 right-4 flex items-center justify-center rounded-2xl"
                  style={{
                    width: "50px", height: "50px",
                    background: "linear-gradient(135deg, #6ee85a 0%, #3dcc40 100%)",
                    boxShadow: "0 4px 12px rgba(61,204,64,0.45)",
                  }}
                >
                  <BadgeIcon />
                </div>
              </div>

              {/* White info footer */}
              <div className="bg-white px-5 py-5 rounded-b-3xl">
                <h4
                  className="font-extrabold text-base mb-2"
                  style={{ color: "#3dcc40" }}
                >
                  {label}
                </h4>
                {content}
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}